<button class="open-modal-button" data-testid="open-esim-info-modal-button" (click)="openModal()">
  <img alt="Smilende telefon" [src]="(themeService.selectedTheme | async)?.phone_slanted_illustration" />
  <span>Sjekk om telefonen støtter eSIM</span>
  <mat-icon [svgIcon]="IconNames.ice_chevron_right" />
</button>

<dialog #esimDialog>
  <div class="dialog-header">
    <h2>eSIM-kompatible telefoner</h2>
    <app-ice-icon-button
      testId="close-esim-compatible-phones-dialog"
      [iconName]="IconNames.ice_close_thick"
      (clicked)="closeModal()"
    />
  </div>
  @if ((eSimCompatiblePhones$ | async)?.htmlAnswer; as innerHTML) {
    <div class="phone-list" [innerHTML]="innerHTML"></div>
  } @else {
    <app-spinner />
  }
</dialog>
